export default __webpack_public_path__ + "static/cheer-shoes-vertical-86aaf398bb09be3304816a0f25cf2e6b.png";